"use client";
import Link from 'next/link';

export default function NotFound() {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="text-center">
        <h1 className="text-6xl font-bold text-gray-900 mb-4">404</h1>
        <h2 className="text-2xl font-semibold text-gray-700 mb-4">Page Not Found</h2>
        <p className="text-gray-600 mb-8">The page you're looking for doesn't exist.</p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link 
            href="/products"
            className="bg-[#0B4866] text-white px-8 py-3 rounded-lg hover:bg-[#094058] transition-all transform hover:scale-[1.02] active:scale-95 shadow-md font-medium"
          >
            Explore All Products
          </Link>
          <Link 
            href="/"
            className="border border-[#0B4866] text-[#0B4866] px-8 py-3 rounded-lg hover:bg-gray-100 transition-all font-medium"
          >
            Go Home
          </Link>
        </div>
      </div>
    </div>
  );
}
